import { Separator } from "@/components/separator";
import { Experiment } from "@/http/api-types";
import { VertexRunsPanel } from "@/pages/experiments/components/VertexRunsPanel";
import { StabilityTab } from "./StabilityTab";

type ModelHealthTabProps = {
  experiment: Experiment;
};

// ModelHealthTab groups the health signals for the prediction models/pipelines behind an
// experiment: Vertex AI pipeline-run outcomes and global prediction stability (drift). These are
// read-only diagnostics about the models, distinct from the experiment's delivery metrics.
export function ModelHealthTab({ experiment }: ModelHealthTabProps) {
  return (
    <section className="space-y-8">
      <StabilityTab experiment={experiment} />
      <Separator />
      <VertexRunsPanel experimentId={experiment.id ?? null} />
    </section>
  );
}
